import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/**
 * Cliente do navegador com a chave ANON. Ela e publica por design: quem protege
 * o dado e a RLS (documento 05). A service_role jamais entra aqui.
 */
export const supabase: SupabaseClient | null =
  url && anonKey ? createClient(url, anonKey) : null;

export const hasSupabase = supabase !== null;

const MISSING_TABLE = new Set(['PGRST205', '42P01']);

/** Tabela ainda não migrada: PostgREST responde PGRST205, Postgres cru 42P01. */
export function isMissingTable(error: { code?: string | null } | null | undefined): boolean {
  return !!error?.code && MISSING_TABLE.has(error.code);
}
